import { Component, Renderer2, ViewChild, ViewEncapsulation, OnDestroy } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { SiriusBaseComponent } from "sirius-framework";
import { LoginComponent } from "../shared/components/login/login.component";
import { Images } from "../shared/models/images.model";
import { Location } from '@angular/common';
import { CommonService } from "../shared/service/shared.service";
import { SiteLanguageService } from "../shared/service/site-language.service";
import { Subscription } from "rxjs";
import { LandingLoginModel } from "./landing-login.model";
import { LandingLoginService } from "./landing-login.service";

/** String resource — boşsa Türkçe varsayılan */
const LANDING_LOGIN_KEYS = {
    bannerText: 'yediEminLoginBannerText',
    bannerButtonBeforeLogin: 'yediEminLoginBannerBtnBeforeLogin',
    bannerButtonAfterLogin: 'yediEminLoginBannerBtnAfterLogin',
    documentTitle: 'yediEminLoginDocumentTitle',
};

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'landing-login',
    templateUrl: './landing-login-component.html',
    styleUrls: ['./landing-login-component.css']
})
export class LandingLoginComponent extends SiriusBaseComponent<LandingLoginModel> implements OnDestroy {

    private langSub: Subscription;

    apiData: LandingLoginModel;
    loggedIn: boolean = false;
    public bannerText = 'Güvenli Ödeme Sistemi';
    public bannerButtonTextBeforeLogin = 'Kayıt';
    public bannerButtonTextAfterLogin = 'Giriş';
    /** Tarayıcı sekmesi başlığı */
    documentTitle = 'Güvenli Ödeme Sistemi | QNB';
    public bannerButtonLinkBeforeLogin = '';
    public bannerButtonLinkAfterLogin = '';
    _images = Images;
    isTop = true;

    isSubmitted: boolean = false;
    @ViewChild(LoginComponent) loginComponent: LoginComponent;
  kvkkClickableLink: any;
  //goToLandingIntervalId: Time;
    
    constructor(private service: LandingLoginService, private router: Router,
        private commonService: CommonService, private locationService: Location,
        private domSanitizer: DomSanitizer, private renderer: Renderer2,
        private siteLanguage: SiteLanguageService) {
        super();
        this.commonService.navigationService = this.navigationService;
        this.commonService.sessionService = this.sessionService;
        this.commonService.dataService = this.dataService;
    }

    OnInit() {
        this.langSub = this.siteLanguage.languageCode$.subscribe(() => {
            this.loadLandingLoginResourceStrings();
            document.title = this.documentTitle;
        });
        //this.goToLandingIntervalId = setTimeout(() => {
        //    this.commonService.logOutClientNoRoute();
        //    this.router.navigateByUrl(SharedModel.PageName_Landing); 
        //}, 600000);
    }

    private loadLandingLoginResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.bannerText = r(LANDING_LOGIN_KEYS.bannerText, this.bannerText);
        this.bannerButtonTextBeforeLogin = r(LANDING_LOGIN_KEYS.bannerButtonBeforeLogin, this.bannerButtonTextBeforeLogin);
        this.bannerButtonTextAfterLogin = r(LANDING_LOGIN_KEYS.bannerButtonAfterLogin, this.bannerButtonTextAfterLogin);
        this.documentTitle = r(LANDING_LOGIN_KEYS.documentTitle, this.documentTitle);
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }
     
    okErrorPopup(event: any) {
        this.sessionService.resetIdleTimeout(); 
        this.commonService.logOut(false);
    } 
          
    isLoggedIn(): boolean {
        return this.loggedIn;
    }

    loginButtonClick() {
        this.loggedIn = !this.loggedIn;
    }

    isScrollTop(isTop: boolean) {
        this.isTop = isTop;
    }
}
